<template>
<div>
  <CCard >
      <CCardHeader class="bgcolor grey-header d-flex">
        <div class="d-flex justify-content-between w-100">
          <div>
            <strong>{{ $t("profileList.title") }}</strong>
            <p class="desc pl-0">{{ $t("profileList.desc") }}</p>
          </div>
          
          <div class="d-flex align-items-center">
            <CButton
                @click="navToAddProfile()"
                class="ml-auto mob-w100 btn-info btn-sm"
              >{{ $t('profileList.addCust')}}</CButton>
          </div>
        </div>
      </CCardHeader>
      <CCardBody>
          <CRow>
              <CCol md="4" class="m-auto">
                  <div class="a-name" v-if="orgLs && orgLs.length>0">
                      <label>
                          <strong>{{ $t("profileList.selAgent") }}</strong>
                      </label>
                      <!-- {{profileLs}} -->

                          <div v-if="orgLs.length>0">
                              <multiselect
                                      v-model="selagent"
                                      :label="'name'"
                                      :options="orgLs"
                                      :track-by="'id'"
                                      :disabled="false"
                                      :isMultiple="false"
                                      @input="onChangeAgent"
                                      :searchable="true"
                                      :showLabels="false"
                                      :allow-empty="false"
                              >
                                  <template #noResult>
                                      <strong>{{$t('creditReport.resultEmpty')}}</strong>
                                  </template>
                                  <template #noOptions>
                                      <strong>{{$t('creditReport.optionEmpty')}}</strong>
                                  </template>
                              </multiselect>
                          </div>
                  </div>
              </CCol>
          </CRow>

    <!-- <cFullScreen class="w-100">
              <template #fullScreen> -->
      <cTable
          :fields="profileLsFields"
          :items="profileComputedLs"
          items-per-page-select
          :items-per-page="tableWatchList.itemsPerPage"
          caption="TicketingQueue"
          hover
          :pagination="paginationSettings"
          id="user-manage-table"
         class="w-100 d-flex flex-flow-wrap"
          
          @filtered-items-change="getFilteredAgentCount"
              @page-change="onPageChange"
              @pagination-change="onPaginationChange"
              :sorter="{ resetable: true }"
                   :tableWatchList="tableWatchList"
             @getFields="onSaveColumns"
             :manageColumn="true"
                                    :paginationLenOption="true"
            >
              <!-- <template #over-table>
                <cPaginationLenOption :paginationWatchLs="tableWatchList" />
              </template> -->
          <template #name="{item}">
            <td>
              <div>{{item.name?item.name:''}}</div>
            </td>
          </template>
           <template #mobileNumber="{item}">
            <td>
              <div>{{item.mobileNumber?item.mobileNumber:''}}</div>
            </td>
          </template>
          <template #emailid="{item}">
            <td>
              <div>{{item.emailid?item.emailid:''}}</div>
            </td>
          </template>
          <template #docid="{item}">
            <td>
              <div>{{item.docid?item.docid:''}}</div>
            </td>
          </template>

          <template #creditBal-header>
            <div class="mr-10px ml-10px d-block">
                <div class="d-flex text-center justify-center">
                <div>{{$t('profileList.creditBal')}}</div>
              </div>
               <div class="d-flex" v-if="creditBal && creditBal.length!=0">
                <div v-for="(currency,index) in creditBal" :key="index">{{currency.currencycode}}</div>
              </div>
              <!-- <CRow v-if="creditBal.length!=0" >
                <CCol 
                  v-for="(currency,index) in creditBal"
                  :key="index"
                >{{currency.currencycode}}</CCol>
              </CRow> -->
            </div>
          </template>

           <template #creditBal="{item}">
            <td>
              <CRow v-if="creditBal">
                <CCol
                  v-for="(currency,index) in creditBal"
                  :key="index"
                >
                 <div v-for="(amountObj,aindex) in item.b2bSubagentFinances" :key="aindex">
                    <div v-if="amountObj.currencycode==currency.currencycode">
                        {{amountObj.runningbalance|formatNumber(currency.currencycode)}}
                    </div>
                </div>
                <!-- <div v-if="item.b2bSubagentFinances[currency.currencycode]">
                    {{item.b2bSubagentFinances[currency.currencycode].runningbalance}}
                </div> -->
               
                </CCol>
              </CRow>
            </td>
          </template>

          <template #actions="{item}">
            <td>
                <div class="d-flex">
                  <!-- <div
                              @click.stop="navToEditProfile(item)"
                              col="2.5"
                              class="edit-icon icon-25px c-pointer"
                              color="info removewrap"
                              v-c-tooltip.hover="{ content: $t('agentGroup.editTooltip') , active:false }"
                      >
                        <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="512pt"
                                viewBox="0 0 512 512"
                                width="512pt"
                                style="fill:#3c4b64;"
                        >
                          <path
                                  d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                          />
                          <path
                                  d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                          />
                          <path
                                  d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                          />
                        </svg>
                  </div> -->
                   <CButton @click.stop="navToEditProfile(item)"
               color="success" 
              class="action-c-btn white-space-pre ml-10px   mr-10px">
              {{ $t('profileList.editBtn')}}</CButton>


              <CButton @click.stop="navToPayReceivePage(item)"
               color="success" 
              class="action-c-btn white-space-pre ml-10px   mr-10px">
              {{ $t('profileList.paymentReceive')}}</CButton>


              <CButton @click.stop="onViewTransactions(item)"
                color="primary"
                class="action-c-btn white-space-pre"
              >{{ $t('profileList.viewTransaction')}}</CButton>

            </div>
            </td>
          </template>


                    <template #no-items-view>
                    <div class="text-center my-5">
                      <h3>{{$t("cReport.noItemsView")}}</h3>
                    </div>
                  </template>
         </cTable>
       <!-- </template>
    </cFullScreen> -->
    </CCardBody>
  </CCard>  
</div>
    
</template>
<script>
import cFullScreen from "../../components/cFullScreen";
import cPaginationLenOption from "../../components/dataTable/cPaginationLenOption";
import {
  COMPONENT_NAME,
  PATHNAME,
  ALERT_MODAL_STATUS,
  DEFAULT_DROPDOWN_STATUS,
} from "../../util/constants";
import { ValidationObserver, ValidationProvider, localize } from "vee-validate";
import Logger from "../../services/logger";
import BaseConfiguration from "../../config/base";
import cTextInputComponent from "../../components/form/cTextInputComponent";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../util/apiValidate.js";
import apiGetAllSubAgent from "../../services/apiGetAllSubAgent";
import Multiselect from "vue-multiselect";
import router, { navigate, goBack, updateDataEdited } from "../../router/index";
import cAlertModal from "../../components/form/cAlertModal";
import {
  cloneData,
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  cloneDeep
} from "../../util/util";
import cTable from "../../components/dataTable/cTable";

export default {
  name: COMPONENT_NAME.PROFILE_LIST,
  components: {
    cFullScreen,
    cAlertModal,
    cPaginationLenOption,
    ValidationObserver,
    ValidationProvider,
    cTextInputComponent,
    Multiselect,
    cTable
  },
  data: () => ({
    profileLs: [],
    selProfileLs: [],
    orgLs:[],
    selagent:null,
    paginationSettings: {
      align: "start"
    },
    profileLsFields: [],
    alertValue: null,
    tableWatchList: {
      filteredlistCount: null,
      itemsPerPage: 25,
      currentPageNum: 1
    },
    creditBal: null,
  }),

  computed: {
    profileComputedLs () {
      let retValue=[];
      if(this.profileLs){
     this.profileLs.forEach(item => {
            if (item && item.b2bSubagentFinances){
                item.creditBal=0;
               
                item.b2bSubagentFinances
                  .map(amountObj => {
                    if (Number(amountObj.runningbalance)) 
                    {
                    item.creditBal=item.creditBal+Number(amountObj.runningbalance);
                    }
                   
                  })


                  retValue.push(item)
            }
          });
      }
          return retValue;

  },
  },
  async created() {
    this.profileLs = await this.getAllSubAgent();
    if(this.profileLs && this.profileLs.length>0){
      this.selProfileLs = this.profileLs;
      this.orgLs = this.getLsForDP(this.profileLs);
    }
    this.profileLsFields = this.getProfileLsFields();
        // let ProfileList = cloneDeep(this.profileLs)
    let profileList = JSON.parse(JSON.stringify((this.profileLs)));
      
     this.toGetCreditBal(profileList);
  },

  methods: {
            ...mapActions("sCreditSaleReport", ["SET_SELECTED_AGENT_OBJ"]),

            navToEditProfile(pSelectedObj){
              try {
          if(BaseConfiguration.isDebug) console.log("navToEditProfile");
           this.SET_SELECTED_AGENT_OBJ(pSelectedObj);
         navigate(PATHNAME.ADD_PROFILE)
          } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PROFILE_LIST,
                  "error in navToEditProfile",
                  err.toString(),
                  "navToEditProfile",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
            },

 navToPayReceivePage(pSelectedObj) {
        try {
          if(BaseConfiguration.isDebug) console.log("navToPayReceivePage");
          // if(this.profileLs ){
          //   for (let i = 0; i < this.profileLs.length; i++) {
          //    if(this.profileLs[i].id == pSelectedObj.id){
          //      let k=0;
          //     for (let j = 0; j < this.creditBal.length; j++) {
          //       if(this.profileLs[i].b2bSubagentFinances[this.creditBal[j].currencycode]) {
          //         this.profileLs[i].b2bSubagentFinances[k] = 
          //         this.profileLs[i].b2bSubagentFinances[this.creditBal[j].currencycode];
          //       }
          //       k++;
          //     }
          //      pSelectedObj = this.profileLs[i];
          //    }
              
          //   }
          // }
          this.SET_SELECTED_AGENT_OBJ(pSelectedObj);
         navigate(PATHNAME.PAYMENT_RECEIVED)
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PROFILE_LIST,
                  "error in navToPayReceivePage",
                  err.toString(),
                  "navToPayReceivePage",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
  },

    onViewTransactions(pSelectedObj) {
        try {
          if(BaseConfiguration.isDebug) console.log("onViewTransactions");
          this.SET_SELECTED_AGENT_OBJ(pSelectedObj);
         navigate(PATHNAME.CREDIT_SALES_REPORT)
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PROFILE_LIST,
                  "error in onViewTransactions",
                  err.toString(),
                  "onViewTransactions",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
  }, 

    navToAddProfile() {
        try {
          if(BaseConfiguration.isDebug) console.log("navToAddProfile");
          this.SET_SELECTED_AGENT_OBJ(null);
          navigate(PATHNAME.ADD_PROFILE)
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PROFILE_LIST,
                  "error in navToAddProfile",
                  err.toString(),
                  "navToAddProfile",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
    }, 

       onSaveColumns(pFields) {
    try {
      if(BaseConfiguration.isDebug) console.log("onSaveColumns");
      this.profileLsFields=pFields;
      

    } catch (err) {
            let body = Logger.buildRequest(
            COMPONENT_NAME.PROFILE_LIST,
              "error in onSaveColumns",
              err.toString(),
              "onSaveColumns",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 
    getLsForDP(pProfileLs) {
      let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getLsForDP");
          retValue = cloneData(pProfileLs);
          let allAgt;
        allAgt = {
          name: DEFAULT_DROPDOWN_STATUS.ALL,
          id: null
        };
        this.selagent = allAgt;
        retValue.unshift(allAgt);
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PROFILE_LIST,
                  "error in getLsForDP",
                  err.toString(),
                  "getLsForDP",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    },

    toGetCreditBal(pProfileLs) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("toGetCreditBal");
        if (pProfileLs) {
          for (let i = 0; i < pProfileLs.length; i++) {
            let creditBalObj = [];
            if (pProfileLs[i].b2bSubagentFinances) {
              for (
                let j = 0;
                j < pProfileLs[i].b2bSubagentFinances.length;
                j++
              ) {
                retValue.push(pProfileLs[i].b2bSubagentFinances[j]);

                creditBalObj[
                  pProfileLs[i].b2bSubagentFinances[j].currencycode
                ] = pProfileLs[i].b2bSubagentFinances[j];
              }
              pProfileLs[i].b2bSubagentFinances = creditBalObj;
            }
          }
          retValue = Array.from(new Set(retValue.map(a => a.currencycode))).map(
            currencycode => {
              return retValue.find(a => a.currencycode === currencycode);
            }
          );
          this.creditBal = retValue;
          //  retValue= [...new Set(retValue)]
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PROFILE_LIST,
          "error in toGetCreditBal",
          err.toString(),
          "toGetCreditBal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return pProfileLs;
    },

    getFilteredAgentCount(pFilteredItems) {
      try {
        if (BaseConfiguration.isDebug) console.log("getFilteredAgentCount");
        this.tableWatchList.filteredlistCount = pFilteredItems.length;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_AGENT,
          "error in getFilteredAgentCount",
          err.toString(),
          "getFilteredAgentCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPaginationChange(pItemsPerPage) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPaginationChange");
        this.tableWatchList.itemsPerPage = pItemsPerPage;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_AGENT,
          "error in onPaginationChange",
          err.toString(),
          "onPaginationChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPageChange(pPageNum) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPageChange");
        this.tableWatchList.currentPageNum = pPageNum;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.MANAGE_AGENT,
          "error in onPageChange",
          err.toString(),
          "onPageChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getProfileLsFields() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getReportTableFields");
        retValue = [
          {
            key: "name",
            label: this.$t("profileList.agtName"),
            isLocked: true
          },

          {
            key: "mobileNumber",
            label: this.$t("profileList.mbl"),
            isLocked: false
          },

          {
            key: "emailid",
            label: this.$t("profileList.email"),
            isLocked: false
          },
          {
            key: "docid",
            label: this.$t("profileList.idNo"),
            isLocked: false
          },

          {
            key: "creditBal",
            label: this.$t("profileList.creditBal"),
            isLocked: true
          },
          {
            key: "actions",
            label: this.$t("profileList.actions"),
            sorter: false,
            isLocked: true
          }
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.PROFILE_LIST,
          "error in getReportTableFields",
          err.toString(),
          "getReportTableFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    onChangeAgent(pselAgent) {
        try {
          if(BaseConfiguration.isDebug) console.log("onChangeAgent");
          this.selagent = pselAgent;
          if(pselAgent.name != DEFAULT_DROPDOWN_STATUS.ALL){
            this.profileLs = [this.selagent]
          } else{
            this.profileLs = this.selProfileLs
          }


        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.PROFILE_LIST,
                  "error in onChangeAgent",
                  err.toString(),
                  "onChangeAgent",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }

    },

    async getAllSubAgent() {
      let retValue;
      try {
        let getAllSubAgentReq;

        getAllSubAgentReq = apiGetAllSubAgent.buildRequest();

        if (getAllSubAgentReq) {
          let getAllSubAgentRes = await apiGetAllSubAgent.getResponse(
            getAllSubAgentReq
          );

          if (VALIDATE_SUCCESS_RES(getAllSubAgentRes)) {
            retValue = getAllSubAgentRes.data.data.allSubAgents;
            
            this.alertValue = null;
          } else {
            let error = getErrorMessage(getAllSubAgentRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid agent";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.SYSTEM_TICKET_NOW,
          "error in getting response from getAllSubAgent API",
          err.toString(),
          "getAllSubAgent",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    }
  }
};
</script>